import { AiReadingSource, AiUsagePayload } from '../redux/jobs/jobs.types';

// Counts the AI requests a single reading costs. Lives in a ref of the screen that submits the
// reading and is passed down to wherever requests are sent; incremented right BEFORE a request
// goes out, because a timed-out or aborted request still costs.
export interface AiUsageCounter {
    countFastDetect: () => void;
    countEvaluate: () => void;
    reset: () => void;
    snapshot: () => { fastDetectCount: number; evaluateCount: number };
}

export const createAiUsageCounter = (): AiUsageCounter => {
    let fastDetectCount = 0;
    let evaluateCount = 0;

    return {
        countFastDetect: () => {
            fastDetectCount += 1;
        },
        countEvaluate: () => {
            evaluateCount += 1;
        },
        reset: () => {
            fastDetectCount = 0;
            evaluateCount = 0;
        },
        snapshot: () => ({ fastDetectCount, evaluateCount }),
    };
};

// undefined when nothing was sent — a reading without any AI request carries no aiUsage at all.
export const toAiUsagePayload = (counter: AiUsageCounter | undefined, mode: AiReadingSource): AiUsagePayload | undefined => {
    if (!counter) {
        return undefined;
    }

    const { fastDetectCount, evaluateCount } = counter.snapshot();

    if (fastDetectCount === 0 && evaluateCount === 0) {
        return undefined;
    }

    return { mode, fastDetectCount, evaluateCount };
};
